import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function Hero() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      headline: 'Stop getting filtered out by ATS. Tailor your resume to each job in minutes.',
      subheadline: "CV Go App generates a job-matched, ATS-ready resume (professional PDF) and a formal 1-page cover letter—based on the exact job post you're applying to.",
      price: '$9.99/year — one annual payment. 12 months of access.',
      features: 'English/Spanish auto-detect • OCR supported • Export as text or PDF',
      cta: 'Get CV Go App',
      imageAlt: 'CV Go App Interface showing ATS optimization success',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/9ANh7Saaj9kfM4G2PRBWzT/tablet_en_ingles.png'
    },
    es: {
      headline: 'Evita que el ATS te descarte. Adapta tu CV a cada oferta en minutos.',
      subheadline: 'CV Go App genera un CV adaptado al puesto y compatible con ATS (PDF profesional) y una carta de presentación formal de 1 página, usando la oferta específica a la que estás postulando.',
      price: '$9.99/año — pago anual único. 12 meses de acceso.',
      features: 'Detección automática EN/ES • OCR para PDFs • Exporta en texto o PDF',
      cta: 'Comprar CV Go App',
      imageAlt: 'Interfaz de CV Go App mostrando optimización ATS exitosa',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/tf1WnpHFTFrJHmZBueRrFg/tablet_en_espanol.png'
    }
  };
  const t = content[language];
  return <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-gradient-to-b from-blue-50/50 to-white" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-41">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-6 leading-tight" data-id="element-42">
            {t.headline}
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-43">
            {t.subheadline}
          </p>

          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-44">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-100 text-blue-800 font-medium text-sm" data-id="element-45">
              {t.price}
            </span>
            <p className="text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-46">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-47" />
              {t.features}
            </p>
          </div>

          <div className="flex justify-center mb-16" data-id="element-48">
            <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded-full text-white bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200" data-id="element-49">
              {t.cta}
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-50" />
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-5xl mx-auto" data-id="element-51">
          <div className="relative rounded-2xl shadow-2xl overflow-hidden border-4 border-white bg-gray-900" data-id="element-52">
            <img src={t.imageUrl} alt={t.imageAlt} className="w-full h-auto object-cover" data-id="element-53" />
          </div>
          {/* Decorative blur behind image */}
          <div className="absolute -inset-4 bg-blue-500/20 blur-3xl -z-10 rounded-[3rem]" data-id="element-54" />
        </motion.div>
      </div>
    </section>;
}